import { formatDateTime } from '@pickleballinc/lib/format-dates';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

interface ArticleCardProps {
  imageUrl: string;
  title: string;
  description?: string;
  type?: 'paginationContain' | 'paginationCover' | 'latest' | 'popular';
  publishedAt?: string;
  alt?: string;
  authorFullName: string;
}

export const MemeArticleCard = ({
  imageUrl,
  title,
  type = 'paginationCover',
  publishedAt,
  alt,
  authorFullName,
}: ArticleCardProps) => {
  const typeStyles = {
    paginationContain: 'w-full max-w-[383px]',
    paginationCover: 'w-full max-w-[383px]',
    latest: 'w-full max-w-[799px]',
    popular: 'w-full max-w-[382px]',
  };

  return (
    <div
      className={`flex cursor-pointer flex-col rounded-t-xl bg-white text-gray-900 shadow-md border rounded-xl sm:shadow-transparent ${typeStyles[type]}`}
    >
      <div className={`overflow-hidden rounded-t sm:rounded-t-xl`}>
        <img
          src={`${getCDNURL(imageUrl || PICKLEBALL_PLACEHOLDER_IMAGE, 1000, 1000)}`}
          alt={alt ? alt : title}
          className='!w-full rounded-t-xl object-cover'
        />
      </div>
      <div className='flex flex-col gap-3 px-4 py-3 rounded-b-xl'>
        <div>
          <p className='text-xs font-medium sm:text-sm text-brand-700'>Meme</p>
          <h3 className='line-clamp-4 text-base text-gray-900 font-semibold'>{title}</h3>
        </div>
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row gap-3'>
            <div className='flex gap-1'>
              {/* TODO: Add author image when it arrives in payload
                 <Avatar size="sm" /> 
                */}
              <div className='flex flex-col justify-between gap-1'>
                <div
                  className='relative text-xs font-medium leading-none text-gray-900'
                  itemScope
                  itemProp='author'
                  itemType='https://schema.org/Person'
                >
                  <span itemProp='name'>{authorFullName}</span>
                </div>
                {type === 'paginationCover' && publishedAt ? (
                  <p className='my-2 text-gray-500 text-xs'>
                    {formatDateTime(publishedAt, { localTimezone: true })}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
